import { render } from "./TextboxComponent.vue?vue&type=template&id=2bfe0cfc"
import script from "./TextboxComponent.vue?vue&type=script&lang=js"
export * from "./TextboxComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__